import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';

import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';

export default class BetakeyUsersScreen extends React.Component {
    constructor(props) {
        super(props);
        this.refreshState = this.refreshState.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.state = {
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
        };

        this.API_ENDPOINT = `betakeys/${props.match.params.keyId}/users/`;
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${event.currentTarget.dataset.name || ''}?`)) {
            Fetcher(`${this.API_ENDPOINT + event.currentTarget.id}/`, 'DELETE', this.refreshState);
        }
    }

    columns = [{
        Header: 'Ключ',
        accessor: 'betakey',
    }, {
        Header: 'E-mail',
        accessor: 'email',
    }, {
        Header: 'IP',
        accessor: 'ip',
    }, {
        Header: '',
        accessor: 'id',
        maxWidth: 40,
        Cell: (row) => (
            <Button size="sm" variant="link" id={row.value} data-name={row.original.betakey} to="#" onClick={this.removeItemHandler}>
                <FontAwesomeIcon id={row.value} icon="trash" />
            </Button>
        ),
    },
    ];

    render() {
        return (
            <TableScreenWithoutUpdate
                columns={this.columns}
                endpoint={this.API_ENDPOINT}
                data={this.state}
            />
        );
    }
}
